import { AfterViewInit, Component, Inject, OnInit, ViewChild } from '@angular/core';
import { Store } from '@src/store';
import { IRule } from '@src/interfaces/rule.interfaces';
import { policyEngineActions } from '@src/store/reducers/policyEngineReducer';
import moment from 'moment';
import { DialogManagerService, SessionService } from '@src/services';
import { TranslatePipe } from '@app/shared/pipes/translate.pipe';
import lodash from 'lodash';
import jquery from 'jquery';
import { RuleListComponent } from './rule-list/rule-list.component';


@Component({
    selector: 'rules-management',
    template: require('./rules-management.component.html'),
    styles: [require('./rules-management.component.scss')]
})
export class RulesManagementComponent implements OnInit, AfterViewInit {
    public result: any;
    public processData: any;

    public currentUserId: number;
    public rules: any;
    public selectedItem: any;
    public tempItem: any;
    public newSelectedItem: IRule;
    public indexInList: number = 0;
    private onRefreshResultList: Boolean;
    private categoriesWithRules: any;
    public onBlockSubscription: boolean;
    private translations: any;
    @ViewChild('nameRef') listChildRef : RuleListComponent;

    constructor(@Inject('$scope') private scope: any,
                @Inject('$filter') public filter: any,
                private store: Store,
                private sessionService: SessionService,
                private dialogManagerService: DialogManagerService,
                private translatePipe: TranslatePipe,
                @Inject('$state') public state: any) {
        this.onBlockSubscription = false;
        this.onRefreshResultList = false;
        this.currentUserId = state.$current.locals.globals.userDetails.data.id;
    }

    public async ngAfterViewInit() {
        
    }

    public async ngOnInit() {
        this.translatePipe.transform(['ERROR', 'UNEXPECTED_ERROR', 'ERROR_NO_DB_TYPE',
            'ERROR_INVALID_TIME_FORMAT', 'ERROR_INVALID_TIME', 'ERROR_REQUIRE_ONE_DAY',
            'ERROR_REQUIRE_ONE_DAY', 'ERROR_EXPRESSION_EMPTY']).then(value => this.translations = value);
        await this.apiRequests(policyEngineActions.GET_POLICIES_ENUMS);
        if (!this.locateExistingNewRule()) {
            await this.apiRequests(policyEngineActions.GET_POLICIES_RULES);
        }
        this.ruleDataProcessing();
    }

    private ruleDataProcessing(): void {
        if (this.onBlockSubscription) {
            this.onBlockSubscription = false;
        } else {
            if (this.store.getState().policyEngine.policies_meta_data) {
                this.processData = this.filter('policyRulesServerToClient')(
                    this.store.getState().policyEngine.policies_rule_data,
                    this.store.getState().policyEngine.policies_meta_data)[0];
                this.processData.MetaData.DbType = lodash.orderBy(this.processData.MetaData.DbType, ['Value'], ['asc']);
                if (this.store.getState().policyEngine.policies_rule_data) {
                    this.selectedItem = this.processData;
                }
            }
            if (this.store.getState().policyEngine.policies_rules && !this.locateExistingNewRule()) {
                this.rules = this.store.getState().policyEngine.policies_rules;
                if (!this.result || this.result.length === 0 || this.onRefreshResultList) {
                    this.categoriesWithRules = lodash.groupBy(this.rules, 'category.Value');
                    this.result = [];
                    Object.keys(this.categoriesWithRules).forEach((key) => {
                        this.result.push({ name: key, value: this.categoriesWithRules[key] });
                    });
                    this.onRefreshResultList = false;
                    this.scope.$apply();
                }
            }

        }
    }
    private async apiRequests(action: any) {
        await this.store.dispatch({ type: action, payload: {} });
    }

    public getRule(data) {
        const { selectedItem } = data;
        if ((!this.locateExistingNewRule() || !selectedItem.isNew || !selectedItem.category) && selectedItem.id) {
            this.store.dispatch({
                type: policyEngineActions.GET_POLICIES_RULE_DETAILS,
                payload: { ruleId: selectedItem.id }
            }).then(() => {
                this.ruleDataProcessing();
            });
        } else {
            if (!selectedItem.category && !selectedItem.isNew) {
                this.selectedItem = {};
                this.selectedItem.isCategory = true;
                this.selectedItem.name = data.selectedItem.name;
            } else {
                this.selectedItem = this.newSelectedItem;
            }
        }
        // });
    }

    public addRule(): void {
        const newRule = this.getDefaultRule();
        if (!this.locateExistingNewRule()) {
            this.selectedItem = newRule;
            this.newSelectedItem = newRule;
            this.indexInList = 0;
            this.result = [{
                id: 0,
                name: 'New Rule',
                isNew: true
            }, ...this.result];
            setTimeout(() => { jquery('ul.dbm-list > li:first-child').click(); }, 50);
        }
    }

    private getDefaultRule(): IRule {
        const user = this.sessionService.user;
        const currentUserName = user ? user.username : '';
        const now = new Date();
        const offset = -now.getTimezoneOffset() / 60;
        const tz = lodash.find(this.processData.MetaData.TimeZones, t => t.Key === offset);
        const selectedTz = (tz) ? tz : this.processData.MetaData.TimeZones[0];
        return {
            CategorySelection: this.processData.MetaData.Rules.Categories[0],
            DBTypeSelection: this.processData.MetaData.DbType,
            category: this.processData.MetaData.Rules.Categories[0],
            createdBy: currentUserName,
            createdDate: moment().toDate(),
            dbTypes: this.processData.MetaData.DbType,
            Days: {},
            name: 'New Rule',
            isNew: true,
            RuleTypeSelection: this.processData.MetaData.Rules.RuleType[0],
            TimingMode: true,
            typeId: this.processData.MetaData.Rules.RuleType[0].Key,
            utcShift: selectedTz.Key,
            utcShiftSelection: selectedTz,
            endTime: moment().add(1, 'h').format('HH:mm'),
            endDateObj: moment().add(1, 'h').format('HH:mm'),
            startTime: moment().format('HH:mm'),
            startDateObj: moment().format('HH:mm')
        };
    }

    public onCancel() {
        if (this.selectedItem.isNew) {
            const newRule = this.getDefaultRule();
            this.selectedItem = newRule;
            this.newSelectedItem = newRule;
            this.indexInList = 0;
            this.result[0].name = 'New Rule';
        } else {
            setTimeout(() => { jquery('.rules-container').find('ul.dbm-list > li.selected').click(); }, 50);
        }
    }

    private locateExistingNewRule(): boolean {
        return lodash.find(this.result, rule => rule.isNew);
    }

    public async onSaveRule() {
        this.onBlockSubscription = true;
        let rule = Object.assign({}, this.selectedItem);
        const isNewMode = rule.isNew;
        const ruleTypeId = rule.RuleTypeSelection.Key;
        rule.category = rule.CategorySelection;
        rule.typeId = ruleTypeId;
        // we call the relevent call here
        if (!this.isRuleValid(rule)) {
            return;
        }
        rule = this.prepItemForServer(rule);
        this.onBlockSubscription = false;
        if (isNewMode) {
            rule.id = 0;
            rule.userId = this.currentUserId; // 1;
            this.result[0].name = rule.name;
            this.result[0].category = rule.category;
            const policy = await this.store.dispatch({
                type: policyEngineActions.ADD_POLICY_RULE,
                payload: { params: { typeId: rule.typeId, internalRule: rule } } });
            this.onRefreshResultList = true;
            if (!policy) {
                this.dialogManagerService.showErrorDialog({ title: this.translations['ERROR'],
                    text: this.translations['UNEXPECTED_ERROR'] });
            } else {
                const newRule = lodash.find(this.result, tRule => tRule.isNew);
                delete newRule.isNew;
                delete rule.isNew;
                //this.tempItem = this.selectedItem
                await this.store.dispatch({ type: policyEngineActions.GET_POLICIES_RULES, payload: {} });     
                await this.store.dispatch({ type: policyEngineActions.GET_POLICIES_ENUMS, payload: {} });
                           
                this.ruleDataProcessing();
                
                //this.listChildRef.selectRuleByName(this.tempItem);
                //this.selectedItem = this.tempItem;                
            }
        } else {
            const editPolicy = await this.store.dispatch({ type: policyEngineActions.EDIT_POLICY_RULE, payload:
                    { ruleId: rule.id, params: rule } });
            if (!editPolicy) {
                this.dialogManagerService.showErrorDialog({ title: this.translations['ERROR'],
                    text: this.translations['UNEXPECTED_ERROR'] });
            } else {
                this.rules.map((item) => {
                    if (item.id === this.selectedItem.id) {
                        item.name = this.selectedItem.name;
                    }
                });
                delete this.selectedItem.isNew;
                await this.store.dispatch({ type: policyEngineActions.GET_POLICIES_RULES, payload: {} });
            }
            
            //this.ruleDataProcessing();
        }
    }

    private isRuleValid(rule) {
        const TimingMode = rule.TimingMode;
        const regex = /^([01]\d|2[0-3]):?([0-5]\d)$/;
        let returnValue = true;
        if (rule.DBTypeSelection.length <= 0) {
            this.dialogManagerService.showErrorDialog({
                title: this.translations['ERROR'],
                text: this.translations['ERROR_NO_DB_TYPE']
            });
            returnValue = false;
        }
        if (TimingMode) {
            const days = `${(rule.Days.Sunday) ? 1 : 0},${(rule.Days.Monday) ? 1 : 0},${(rule.Days.Tuesday) ? 1 : 0},${(rule.Days.Wenesday) ? 1 : 0},${(rule.Days.Thursday) ? 1 : 0},${(rule.Days.Friday) ? 1 : 0},${(rule.Days.Saturday) ? 1 : 0}`;
            if (!regex.test(rule.startDateObj) || !regex.test(rule.endDateObj)) {
                this.dialogManagerService.showErrorDialog({
                    title: this.translations['ERROR'],
                    text: this.translations['ERROR_INVALID_TIME_FORMAT']
                });
                returnValue = false;
            }

            if (!this.validDateTimeRange(rule.startDateObj, rule.endDateObj)) {
                this.dialogManagerService.showErrorDialog({
                    title: this.translations['ERROR'],
                    text: this.translations['ERROR_INVALID_TIME']
                });
                returnValue = false;
            }

            if (days === '0,0,0,0,0,0,0') {
                this.dialogManagerService.showErrorDialog({
                    title: this.translations['ERROR'],
                    text: this.translations['ERROR_REQUIRE_ONE_DAY']
                });
                returnValue = false;
            }
        }

        if (!TimingMode) {
            if (!rule.expression || rule.expression === '') {
                this.dialogManagerService.showErrorDialog({
                    title: this.translations['ERROR'],
                    text: this.translations['ERROR_EXPRESSION_EMPTY']
                });
                returnValue = false;
            }
        }
        return returnValue;
    }

    public validDateTimeRange(fromTime, toTime) {
        let isValid = true;
        const ft = moment();
        const spFromTime = fromTime.split(':');
        const spToTime = toTime.split(':');
        ft.set({ hour: spFromTime[0], minute: spFromTime[1], second: 0 });
        const tt = moment();
        if (spToTime.length !== 2 || spFromTime.length !== 2) {
            isValid = false;
        }
        // tslint:disable-next-line:brace-style
        else {
            if (toTime === '00:00') {
                tt.set({ hour: 23, minute: 59, second: 59 });
            } else {
                tt.set({ hour: spToTime[0], minute: spToTime[1], second: 0 });
            }
            isValid = ft < tt;
        }
        return isValid;
    }

    public onDeleteRule(): void {
        const onConfirm = () => {
            this.onBlockSubscription = true;
            if (this.locateExistingNewRule()) {
                this.result.splice(0, 1);
                this.selectedItem = this.result[0];
                this.indexInList = 0;
            } else {
                const rule = this.selectedItem;
                this.store.dispatch({ type: policyEngineActions.DELETE_POLICY_RULE, payload: { ruleId: rule.id } })
                    .then((response) => {
                        this.onBlockSubscription = false;
                        this.onRefreshResultList = true;
                        if (response) {
                            this.result.splice(this.indexInList, 1);
                            this.selectedItem = this.result[0];
                            this.indexInList = 0;
                            this.store.dispatch({ type: policyEngineActions.GET_POLICIES_RULES, payload: {} })
                                .then(() => {
                                    this.ruleDataProcessing();
                                });
                        } else {
                            this.dialogManagerService.showErrorDialog({
                                title: this.translations['ERROR'],
                                text: this.translations['UNEXPECTED_ERROR']
                            });
                        }
                    });
            }
        };
        const dialogData = { title: 'Delete Rule', action: 'delete', objectType: 'rule', item: this.selectedItem.name };
        this.dialogManagerService.showConfirmationDialog(dialogData, onConfirm);
    }

    public onDuplicateRule(): void  {
        if (!this.locateExistingNewRule()) {
            let newRule = Object.assign({}, this.selectedItem);
            newRule.name += ' (Copy)';
            const ruleTypeId = newRule.RuleTypeSelection.Key;
            newRule.category = newRule.CategorySelection;
            newRule.typeId = ruleTypeId;
            // delete newRule.id;
            delete newRule.$$hashKey;
            newRule = this.prepItemForServer(newRule);
            this.store.dispatch({ type: policyEngineActions.DUPLICATE_POLICY_RULE, payload: { ruleId: newRule.id } })
                .then((res) => {
                    this.onBlockSubscription = false;
                    this.onRefreshResultList = true;
                    this.result.forEach((item) => {
                        item.value.forEach((rule) => {
                            if (rule.id === newRule.id) {
                                rule.newDuplicateId = res.id;
                            }
                        });
                    });
                    this.store.dispatch({ type: policyEngineActions.GET_POLICIES_RULES, payload: {} })
                        .then(() => {
                            this.ruleDataProcessing();
                        });
                });
        }
    }

    private prepItemForServer(rule) {
        const TimingMode = rule.TimingMode;
        rule.isSensitive = !!(rule.isSensitive);
        delete rule.typeid;
        if (TimingMode) {
            rule.startTime = rule.startDateObj;
            rule.endTime = rule.endDateObj;
            const days = `${(rule.Days.Sunday) ? 1 : 0},${ (rule.Days.Monday) ? 1 : 0},${(rule.Days.Tuesday) ? 1 : 0},${ (rule.Days.Wenesday) ? 1 : 0},${ (rule.Days.Thursday) ? 1 : 0},${ (rule.Days.Friday) ? 1 : 0},${(rule.Days.Saturday) ? 1 : 0}`;
            rule.days = days;
            rule.utcShift = rule.utcShiftSelection.Key;
            rule.createDate = rule.createdDate;
            delete rule.isSensitive;
            delete rule.expression;
        } else {
            delete rule.startTime;
            delete rule.endTime;
        }
        rule.dbTypes = rule.DBTypeSelection;
        delete rule.startDateObj;
        delete rule.endDateObj;
        delete rule.Days;
        delete rule.DBTypeSelection;
        delete rule.TimingMode;
        delete rule.createDate;
        delete rule.CategorySelection;
        delete rule.RuleTypeSelection;
        delete rule.isNew;
        delete rule.Rules;
        delete rule.MetaData;
        delete rule.ruleType;
        delete rule.utcShiftSelection;
        return rule;
    }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/policyEngine/rules-management/rules-management.component.ts